define('app/views/vendor_view',['app/setup', 'app/views/vendor_deal_req_view', 'photo-swipe', 'photo-swipe-ui-default'], function(takhfifan, vendorDealReqView, PhotoSwipe, PhotoSwipeUI_Default) {
  takhfifan.vendorView = takhfifan.BaseView.extend({
    initialize: function() {
      this.$('.vendor-cover a').each(function(i,v){
        $(this).attr('data-img-index', i);
      });
      var openPhotoSwipe = function(openIndex, galleryType) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = [];       
        var externalMediaItems = [];
        var options = {
            history: false,
            focus: false,
            showAnimationDuration: 0,
            hideAnimationDuration: 0
        };
        
        if(galleryType == 'cover'){
          this.$('.vendor-cover a').each(function(i,v){
            items.push({
              src: $(v).find('img').attr('src'),
              w: 600,
              h: 372
            });
          });

          this.$('.vendor-cover-gallery a').each(function(i,v){
            items.push({
              src: $(v).find('img').attr('src'),
              w: 600,
              h: 372
            });
          });

          var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
          gallery.init();
          gallery.goTo(openIndex);
        }
        else if(galleryType == 'externalMedia'){
          this.$('.external-media-gallery img').each(function(i,v){
            var width = $(v).width();
            var height = $(v).height();
            externalMediaItems.push({
              src: $(v).attr('src'),
              w: width,
              h: height
            });
          });
          var externalMedia = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, externalMediaItems, options);
          externalMedia.init();
        }
      };
      this.$('.vendor-cover a').on('click', function() {
        var imgIndex = $(this).data('img-index');
        openPhotoSwipe(imgIndex, 'cover');    
      });
      this.$('.special-link.enable').on('click', function() {
        openPhotoSwipe(0, 'externalMedia');    
      });

      this.initLocationNotification();
    },

    initLocationNotification:function(){
      var _this = this;
      if($('.vendor-page__location').length){
        this.showLocationOffset =$('.vendor-page__deal-section').offset().top;
        this.hideLocationOffset =$('.vendor-page__location').offset().top;
        this.$locbar = $('.vendor-page__location__bar');

        $(window).scroll(function () {
          _this.showLocationNotification();
        });
        this.$locbar.click(function(){
          _this.scrollToLocation();
        });
      }
    },

    showLocationNotification: _.throttle(function(){
      var $window = $(window),
          wh = $window.height(),
          wst = $window.scrollTop();

      if(!(this.$locbar.hasClass('show')) && (wst + wh > this.showLocationOffset)){
        this.$locbar.addClass('show');
      }

      if((this.$locbar.hasClass('show')) && ((wst + wh > this.hideLocationOffset)|| (wst + wh < this.showLocationOffset))){
        this.$locbar.removeClass('show');
      }
    },500),

    scrollToLocation: function () {
      var _this = this;
      $('html, body').animate({
        scrollTop: _this.hideLocationOffset - 20
      }, 500);
    }
  });
});

